// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-list__container {
  height: 100vh;
  max-height: calc(100vh - 80px);
  overflow: overlay;
  padding: 0;
  -webkit-user-select: none;
          user-select: none;
}
.form-list__container--box {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: sticky;
  top: 0;
  background-color: #fff;
  z-index: 555;
}
.form-list__container--empty {
  display: flex;
  justify-content: center;
  align-items: center;
}
.form-list__container::-webkit-scrollbar {
  width: 6px;
}
.form-list__container::-webkit-scrollbar-track {
  background: #fff;
}
.form-list__container::-webkit-scrollbar-thumb {
  background: #eee;
  border-radius: 10px;
}
.form-list__container::-webkit-scrollbar-thumb:hover {
  background: #ccc;
}
.form-list__container .base-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
}
.form-list__container .base-row {
  display: flex;
  flex-direction: column;
}
.form-list__container .base-row__header {
  display: flex;
  padding-top: 5px;
  padding-bottom: 5px;
  border-bottom: solid 1px #ccc;
  font-weight: bold;
}
.form-list__container .base-row__header .name {
  flex: 1 1;
  display: flex;
  justify-content: flex-start;
}
.form-list__container .base-row__header .group {
  flex: 1 1;
  display: flex;
  justify-content: flex-start;
}
.form-list__container .base-row__item {
  padding: 10px;
  display: flex;
  text-decoration: none;
  color: #20212b;
  cursor: pointer;
  border-bottom: solid 1px #ccc;
  transition: all 0.3s ease-in-out;
}
.form-list__container .base-row__item .name {
  flex: 1 1;
  display: flex;
  justify-content: flex-start;
  gap: 10px;
}
.form-list__container .base-row__item .group {
  flex: 1 1;
  display: flex;
  justify-content: flex-start;
}
.form-list__container .base-row__item:hover {
  background-color: #f0f4f9;
}
.form-list__container .base-row .highlight {
  color: #a3e635;
}
@media screen and (max-width: 1500px) {
  .form-list__container .base-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media screen and (max-width: 1200px) {
  .form-list__container .base-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media screen and (max-width: 768px) {
  .form-list__container .base-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media screen and (max-width: 480px) {
  .form-list__container .base-grid {
    grid-template-columns: repeat(1, 1fr);
  }
}

.form-card {
  background-color: #f0f4f9;
  border-radius: 20px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  text-decoration: none;
  color: #20212b;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}
.form-card:hover {
  background-color: #dfe3e7;
  color: #20212b;
}
.form-card:active {
  background-color: #c2e7ff;
}
.form-card__body {
  margin-top: 10px;
  height: 150px;
  display: flex;
  justify-content: center;
  background-color: #fff;
  border-radius: 10px;
  font-size: 5px;
}
.form-card__top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.form-card__top .item {
  display: flex;
  align-items: center;
  gap: 10px;
}
.form-card__top .item .title .highlight {
  color: #a3e635;
}
.form-card__bottom {
  margin-top: auto;
  display: flex;
  align-items: center;
  gap: 10px;
}
.form-card__bottom .name {
  font-size: 14px;
  text-transform: capitalize;
  padding-top: 5px;
}
.form-card__bottom .name .highlight {
  color: #a3e635;
}`, "",{"version":3,"sources":["webpack://./src/routes/DanhMuc/index.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,8BAAA;EAEA,iBAAA;EACA,UAAA;EACA,yBAAA;UAAA,iBAAA;AAAJ;AAEI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,gBAAA;EACA,MAAA;EACA,sBAAA;EACA,YAAA;AAAR;AAGI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AADR;AAII;EACI,UAAA;AAFR;AAII;EACI,gBAAA;AAFR;AAII;EACI,gBAAA;EACA,mBAAA;AAFR;AAII;EACI,gBAAA;AAFR;AAKI;EACI,aAAA;EACA,qCAAA;EACA,SAAA;AAHR;AAMI;EACI,aAAA;EACA,sBAAA;AAJR;AAOQ;EACI,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,6BAAA;EACA,iBAAA;AALZ;AAMY;EACI,SAAA;EACA,aAAA;EACA,2BAAA;AAJhB;AAMY;EACI,SAAA;EACA,aAAA;EACA,2BAAA;AAJhB;AAOQ;EACI,aAAA;EACA,aAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,6BAAA;EACA,gCAAA;AALZ;AAMY;EACI,SAAA;EACA,aAAA;EACA,2BAAA;EACA,SAAA;AAJhB;AAMY;EACI,SAAA;EACA,aAAA;EACA,2BAAA;AAJhB;AAOQ;EACI,yBAAA;AALZ;AAOQ;EACI,cAAA;AALZ;AASI;EACI;IACI,qCAAA;EAPV;AACF;AAUI;EACI;IACI,qCAAA;EARV;AACF;AAWI;EACI;IACI,qCAAA;EATV;AACF;AAYI;EACI;IACI,qCAAA;EAVV;AACF;;AAaA;EACI,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,gCAAA;AAVJ;AAWI;EACI,yBAAA;EACA,cAAA;AATR;AAWI;EACI,yBAAA;AATR;AAWI;EACI,gBAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EACA,cAAA;AATR;AAWI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;AATR;AAWQ;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AATZ;AAYgB;EACI,cAAA;AAVpB;AAeI;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAbR;AAcQ;EACI,eAAA;EACA,0BAAA;EACA,gBAAA;AAZZ;AAcY;EACI,cAAA;AAZhB","sourcesContent":[".form-list__container {\r\n    height: 100vh;\r\n    max-height: calc(100vh - 80px);\r\n    // overflow-y: auto;\r\n    overflow: overlay;\r\n    padding: 0;\r\n    user-select: none;\r\n\r\n    &--box {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        flex-direction: column;\r\n        position: sticky;\r\n        top: 0;\r\n        background-color: #fff;\r\n        z-index: 555;\r\n    }\r\n\r\n    &--empty {\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n    }\r\n\r\n    &::-webkit-scrollbar {\r\n        width: 6px;\r\n    }\r\n    &::-webkit-scrollbar-track {\r\n        background: #fff;\r\n    }\r\n    &::-webkit-scrollbar-thumb {\r\n        background: #eee;\r\n        border-radius: 10px;\r\n    }\r\n    &::-webkit-scrollbar-thumb:hover {\r\n        background: #ccc;\r\n    }\r\n\r\n    .base-grid {\r\n        display: grid;\r\n        grid-template-columns: repeat(5, 1fr);\r\n        gap: 10px;\r\n        // overflow-y: auto;\r\n    }\r\n    .base-row {\r\n        display: flex;\r\n        flex-direction: column;\r\n        // overflow-y: auto;\r\n\r\n        &__header {\r\n            display: flex;\r\n            padding-top: 5px;\r\n            padding-bottom: 5px;\r\n            border-bottom: solid 1px #ccc;\r\n            font-weight: bold;\r\n            .name {\r\n                flex: 1;\r\n                display: flex;\r\n                justify-content: flex-start;\r\n            }\r\n            .group {\r\n                flex: 1;\r\n                display: flex;\r\n                justify-content: flex-start;\r\n            }\r\n        }\r\n        &__item {\r\n            padding: 10px;\r\n            display: flex;\r\n            text-decoration: none;\r\n            color: #20212b;\r\n            cursor: pointer;\r\n            border-bottom: solid 1px #ccc;\r\n            transition: all 0.3s ease-in-out;\r\n            .name {\r\n                flex: 1;\r\n                display: flex;\r\n                justify-content: flex-start;\r\n                gap: 10px;\r\n            }\r\n            .group {\r\n                flex: 1;\r\n                display: flex;\r\n                justify-content: flex-start;\r\n            }\r\n        }\r\n        &__item:hover {\r\n            background-color: #f0f4f9;\r\n        }\r\n        .highlight {\r\n            color: #a3e635;\r\n        }\r\n    }\r\n\r\n    @media screen and (max-width: 1500px) {\r\n        .base-grid {\r\n            grid-template-columns: repeat(4, 1fr);\r\n        }\r\n    }\r\n\r\n    @media screen and (max-width: 1200px) {\r\n        .base-grid {\r\n            grid-template-columns: repeat(2, 1fr);\r\n        }\r\n    }\r\n\r\n    @media screen and (max-width: 768px) {\r\n        .base-grid {\r\n            grid-template-columns: repeat(2, 1fr);\r\n        }\r\n    }\r\n\r\n    @media screen and (max-width: 480px) {\r\n        .base-grid {\r\n            grid-template-columns: repeat(1, 1fr);\r\n        }\r\n    }\r\n}\r\n.form-card {\r\n    background-color: #f0f4f9;\r\n    border-radius: 20px;\r\n    padding: 10px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    text-decoration: none;\r\n    color: #20212b;\r\n    cursor: pointer;\r\n    transition: all 0.3s ease-in-out;\r\n    &:hover {\r\n        background-color: #dfe3e7;\r\n        color: #20212b;\r\n    }\r\n    &:active {\r\n        background-color: #c2e7ff;\r\n    }\r\n    &__body {\r\n        margin-top: 10px;\r\n        height: 150px;\r\n        display: flex;\r\n        justify-content: center;\r\n        background-color: #fff;\r\n        border-radius: 10px;\r\n        font-size: 5px;\r\n    }\r\n    &__top {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: space-between;\r\n\r\n        .item {\r\n            display: flex;\r\n            align-items: center;\r\n            gap: 10px;\r\n\r\n            .title {\r\n                .highlight {\r\n                    color: #a3e635;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    &__bottom {\r\n        margin-top: auto;\r\n        display: flex;\r\n        align-items: center;\r\n        gap: 10px;\r\n        .name {\r\n            font-size: 14px;\r\n            text-transform: capitalize;\r\n            padding-top: 5px;\r\n\r\n            .highlight {\r\n                color: #a3e635;\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
